/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { AwardMedalIcon16Light } from './AwardMedalIcon16Light';
import { AwardMedalIcon16Regular } from './AwardMedalIcon16Regular';
import { AwardMedalIcon16Solid } from './AwardMedalIcon16Solid';
import { AwardMedalIcon20Light } from './AwardMedalIcon20Light';
import { AwardMedalIcon20Regular } from './AwardMedalIcon20Regular';
import { AwardMedalIcon20Solid } from './AwardMedalIcon20Solid';
import { AwardMedalIcon24Regular } from './AwardMedalIcon24Regular';
import { AwardMedalIcon24Solid } from './AwardMedalIcon24Solid';
import { AwardMedalIcon32Regular } from './AwardMedalIcon32Regular';
import { AwardMedalIcon64Regular } from './AwardMedalIcon64Regular';
var sizes = {
    16: {
        light: AwardMedalIcon16Light,
        regular: AwardMedalIcon16Regular,
        solid: AwardMedalIcon16Solid,
    },
    20: {
        light: AwardMedalIcon20Light,
        regular: AwardMedalIcon20Regular,
        solid: AwardMedalIcon20Solid,
    },
    24: {
        regular: AwardMedalIcon24Regular,
        solid: AwardMedalIcon24Solid,
    },
    32: {
        regular: AwardMedalIcon32Regular,
    },
    64: {
        regular: AwardMedalIcon64Regular,
    },
};
export var AwardMedalIcon = forwardRef('AwardMedalIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
